import { apiClient } from './client';
import type { PaginatedResponse, PaginationParams, MessageResponse } from '../types/api';
import type { AdminInvoiceListItem, AdminInvoiceDetail, AdminBatchReprocessRequest } from '../types/invoices';

export const invoicesApi = {
  list: (params: PaginationParams & { status?: string; organization_id?: string }) =>
    apiClient.get<PaginatedResponse<AdminInvoiceListItem>>('/invoices', { params }).then((r) => r.data),
  detail: (id: string) =>
    apiClient.get<AdminInvoiceDetail>(`/invoices/${id}`).then((r) => r.data),
  reprocess: (id: string) =>
    apiClient.post<MessageResponse>(`/invoices/${id}/reprocess`).then((r) => r.data),
  batchReprocess: (data: AdminBatchReprocessRequest) =>
    apiClient.post<MessageResponse>('/invoices/batch-reprocess', data).then((r) => r.data),
  deleteInvoice: (id: string) =>
    apiClient.delete<MessageResponse>(`/invoices/${id}`).then((r) => r.data),
};
